<article class="container">
	<div class="container-content">
		<article>
			<section class="header">
				@if (type === 'checkin') {
					<h1 class="title">Seu check-in foi realizado com sucesso!</h1>
				} @else {
					<h1 class="title">Sua reserva foi realizada com sucesso</h1>
				}
			</section>

			<section class="body">
				<ul>
					<li>
						<p>Nome:</p>
						<span>{{ client.fullName }}</span>
					</li>
					<li>
						<p>Restaurante:</p>
						<span>{{ venue.name }}</span>
					</li>
					<li>
						<p>Data:</p>
						<span>{{ orderDate | date: 'dd/MM/yyyy' }}</span>
					</li>
					<li>
						<p>Horário:</p>
						<span>{{ reservationTime }}</span>
					</li>
					<li>
						<p>Pessoas:</p>
						<span>{{ partySize }} {{ partySize === 1 ? 'pessoa' : 'pessoas' }}</span>
					</li>
				</ul>
			</section>

			<section class="reminder">
				<mat-icon svgIcon="porto-bank-icons:info" />
				<p>
					Lembre-se de pagar a conta do restaurante com seu cartão Porto Bank para ganhar os
					benefícios!
				</p>
			</section>
		</article>
	</div>

	<div class="benefits-container">
		<h2>Benefícios</h2>
		<ul>
			<li *ngFor="let benefit of benefit" class="benefit-item">
				<div class="benefit-item__value">
					<mat-icon svgIcon="porto-bank-icons:check"></mat-icon>
					{{ benefit.type === 'discount' ? benefit.value + ' de desconto' : benefit.name }}
				</div>

				<p>{{ benefit.descriptionLong }}</p>
			</li>
		</ul>
	</div>

	<div class="footer-buttons">
		<button mat-button class="footer-button" (click)="ok.emit()">
			<span>Entendido</span>
		</button>
	</div>
</article>
